import "core-js/modules/es.array.push.js";
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-76f2ba2e"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "news-group-container"
};
const _hoisted_2 = {
  style: {
    "display": "flex",
    "align-items": "center",
    "justify-content": "space-between"
  }
};
const _hoisted_3 = {
  style: {
    "display": "flex",
    "align-items": "center"
  }
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "租户名称", -1));
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "width": "20px"
  }
}, null, -1));
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "width": "20px"
  }
}, null, -1));
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "应用状态", -1));
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "width": "20px"
  }
}, null, -1));
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "width": "20px"
  }
}, null, -1));
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "审核状态", -1));
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "width": "20px"
  }
}, null, -1));
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "width": "20px"
  }
}, null, -1));
const _hoisted_13 = {
  style: {
    "margin-left": "20px"
  }
};
const _hoisted_14 = {
  class: "add-account"
};
const _hoisted_15 = {
  style: {
    "margin-top": "10px",
    "display": "flex",
    "justify-content": "end"
  }
};
import { ref, onMounted } from 'vue';
import ModuleTenant from './components/ModuleTenant';
import tableComponent from './components/Table';
import { delMoudle, findApplyByTenant } from '@/api/authModule';
import usePagination from '@/hooks/usePagination';
import { infoTableDataSchemas, formSchemas, updateFormSchemas } from './config';
import { Refresh, Search } from '@element-plus/icons-vue';
import TenantSelect from '@/components/TenantSelect';
import { ElMessageBox, ElMessage } from 'element-plus';
import { useRoute, useRouter } from 'vue-router';
import { asyncClueConfig } from '@/api/tenant';
export default {
  __name: 'index',
  setup(__props) {
    const tableData = ref([]);
    const tenantId = ref('');
    const applyStatus = ref('');
    const approvalStatus = ref('');

    // loading效果
    const loading = ref(false);
    const route = useRoute();
    const type = route.fullPath.includes('mobile') ? 1 : 2;
    const {
      currentPage,
      total,
      pageSize,
      setPageSize,
      setCurrentPage,
      setTotal
    } = usePagination();
    const getData = async () => {
      loading.value = true;
      const res = await findApplyByTenant({
        pageSize: pageSize.value,
        currentPage: currentPage.value,
        tenantId: tenantId.value,
        applyStatus: applyStatus.value,
        approvalStatus: approvalStatus.value,
        type
      });
      setTotal(res.total);
      tableData.value = res.records;
      loading.value = false;
    };
    const handleRefreshActivity = () => {
      tenantId.value = '';
      applyStatus.value = '';
      approvalStatus.value = '';
      getData();
    };

    /**
     * 更改当前页码
     * @param {*} val
     */
    const handleCurrentChange = val => {
      setCurrentPage(val);
      getData();
    };
    const handleChangeSize = e => {
      setPageSize(e);
      getData();
    };
    const addVisible = ref(false);
    const handleAddRow = () => {
      addVisible.value = true;
    };
    const handleAsync = async row => {
      await asyncClueConfig(row.tenantId);
      ElMessage({
        message: '同步成功',
        type: 'success'
      });
    };
    onMounted(() => {
      getData();
    });
    const isModuleTenantVisible = ref(false);
    const current = ref(null);
    const handleUpadte = row => {
      isModuleTenantVisible.value = true;
      current.value = row;
    };
    const router = useRouter();
    const handleApproval = row => {
      router.push(`/application/approval/${row.id}`);
    };
    const handleDelModule = async row => {
      try {
        await ElMessageBox.confirm('确认删除吗', '温馨提示', {
          confirmButtonText: '确认',
          cancelButtonText: '取消',
          type: 'warning'
        });

        // 如果该租户的子诊所数量为0的话
        await delMoudle(row.id);
        await getData();
        ElMessage({
          message: '删除成功',
          type: 'success'
        });
      } catch (error) {
        console.log(`error${error}`);
      }
    };
    return (_ctx, _cache) => {
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_card = _resolveComponent("el-card");
      const _component_el_pagination = _resolveComponent("el-pagination");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_card, {
        shadow: "never",
        class: "title-card",
        style: {
          "border": "none"
        }
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_hoisted_4, _hoisted_5, _createVNode(_unref(TenantSelect), {
          modelValue: tenantId.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => tenantId.value = $event)
        }, null, 8, ["modelValue"]), _hoisted_6, _hoisted_7, _hoisted_8, _createVNode(_component_el_select, {
          modelValue: applyStatus.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => applyStatus.value = $event),
          style: {
            "width": "200px"
          }
        }, {
          default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList([{
            label: '使用中',
            value: 1
          }, {
            label: '停用',
            value: 2
          }], item => {
            return _createVNode(_component_el_option, {
              key: item.value,
              label: item.label,
              value: item.value
            }, null, 8, ["label", "value"]);
          }), 64))]),
          _: 1
        }, 8, ["modelValue"]), _hoisted_9, _hoisted_10, _hoisted_11, _createVNode(_component_el_select, {
          modelValue: approvalStatus.value,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => approvalStatus.value = $event),
          style: {
            "width": "200px"
          }
        }, {
          default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList([{
            label: '进行中',
            value: 1
          }, {
            label: '审批完成',
            value: 2
          }, {
            label: '拒绝',
            value: 3
          }], item => {
            return _createVNode(_component_el_option, {
              key: item.value,
              label: item.label,
              value: item.value
            }, null, 8, ["label", "value"]);
          }), 64))]),
          _: 1
        }, 8, ["modelValue"]), _hoisted_12, _createElementVNode("div", _hoisted_13, [_createVNode(_component_el_button, {
          type: "primary",
          icon: _unref(Search),
          onClick: getData
        }, {
          default: _withCtx(() => [_createTextVNode(" 查询 ")]),
          _: 1
        }, 8, ["icon"]), _createVNode(_component_el_button, {
          icon: _unref(Refresh),
          onClick: handleRefreshActivity
        }, {
          default: _withCtx(() => [_createTextVNode(" 重置 ")]),
          _: 1
        }, 8, ["icon"])])]), _createElementVNode("div", _hoisted_14, [_createVNode(_component_el_button, {
          type: "primary",
          onClick: handleAddRow
        }, {
          default: _withCtx(() => [_createTextVNode(" 新增 ")]),
          _: 1
        })])])]),
        _: 1
      }), _createVNode(_component_el_card, {
        shadow: "never",
        style: {
          "border": "none"
        }
      }, {
        default: _withCtx(() => [_createVNode(_unref(tableComponent), {
          tableData: tableData.value,
          loading: loading.value,
          schemas: _unref(infoTableDataSchemas),
          onUpdate: handleUpadte,
          onDel: handleDelModule,
          onApproval: handleApproval,
          onAsync: handleAsync
        }, null, 8, ["tableData", "loading", "schemas"]), _createElementVNode("div", _hoisted_15, [_createVNode(_component_el_pagination, {
          onCurrentChange: handleCurrentChange,
          onSizeChange: handleChangeSize,
          "page-sizes": [12, 24, 36],
          "current-page": _unref(currentPage),
          "page-size": _unref(pageSize),
          total: _unref(total),
          layout: "total, sizes, prev, pager, next, jumper"
        }, null, 8, ["current-page", "page-size", "total"])])]),
        _: 1
      }), _createVNode(_unref(ModuleTenant), {
        type: _unref(type),
        modelValue: addVisible.value,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => addVisible.value = $event),
        onRefreshData: getData,
        schemas: _unref(formSchemas)
      }, null, 8, ["type", "modelValue", "schemas"]), _createVNode(_unref(ModuleTenant), {
        type: _unref(type),
        modelValue: isModuleTenantVisible.value,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => isModuleTenantVisible.value = $event),
        model: current.value,
        onRefreshData: getData,
        onClearModel: _cache[5] || (_cache[5] = $event => current.value = null),
        schemas: _unref(updateFormSchemas)
      }, null, 8, ["type", "modelValue", "model", "schemas"])]);
    };
  }
};